import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {
  APP_MENU_CONFIG_TOKEN,
  APP_NAME_TOKEN,
  APP_TOOLBAR_CONFIG_TOKEN,
} from '@epg-apps/epg-modern-layout';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {epgRoutes} from '@epg-apps/epg-routes';
import {customerRoutes} from '@epg-apps/customer-routes';
import {
  AuthenticationService,
  authenticationTokenInterceptor,
  defaultCdhHeadersInterceptor,
} from '@epg-apps/utils';
import {provideAnimations} from '@angular/platform-browser/animations';
import {epgHttpErrorInterceptor} from '@epg-apps/epg-http-error-interceptor';
import {EpgDownloadService} from '@epg-apps/epg-download';
import {ExportService} from '@epg-apps/export-api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([
        defaultCdhHeadersInterceptor,
        authenticationTokenInterceptor,
        epgHttpErrorInterceptor,
      ]),
    ),
    provideRouter(epgRoutes(customerRoutes), withComponentInputBinding()),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideAnimations(),
    AuthenticationService,
    {provide: LOCALE_ID, useValue: 'en'},
    {provide: APP_NAME_TOKEN, useValue: 'CDH'},
    {
      provide: APP_MENU_CONFIG_TOKEN,
      useValue: [{path: '/customers', label: 'Klanten', icon: 'fa-book-user'}],
    },
    {
      provide: APP_TOOLBAR_CONFIG_TOKEN,
      useValue: {
        downloadable: true,
      },
    },
    {
      provide: EpgDownloadService,
      useClass: ExportService,
    },
  ],
};
